export const hasResultsCheck = (reviews, questionnaires = []) =>
  reviews.some(review => review.finishedCount !== 0) ||
  questionnaires.some(questionnaire => questionnaire.finishedCount !== 0);
